// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"%23007bff\"><polygon points=\"0,0 20,0 10,10\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/ApplicationForm/ApplicationForm.css */

.application-form-container {
    padding: 50px;
    max-width: 700px;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    border: 1px solid #4f4a4a;
    border-radius: 10px;
    background-color: #ffffff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    font-family: 'Arial', sans-serif;
}

.application-form-container h1 {
    text-align: center;
    font-size: 2.5em;
    color: #333;
    margin-bottom: 40px;
    margin-top: -10px;
    font-weight: bold;
}

.application-form-container form {
    display: flex;
    flex-direction: column;
}

.application-form-container .input-container {
    position: relative;
    margin-bottom: 30px;
}
.application-form-container .display-value-container {
    position: relative;
    margin-bottom: 1px;
}

.application-form-container label {
    position: absolute;
    left: 12px;
    top: 12px;
    font-weight: bold;
    color: #555;
    transition: 0.2s ease all;
    pointer-events: none; /* Prevents label from capturing clicks */
}

.application-form-container input,
.application-form-container textarea {
    padding: 20px;
    padding-top: 20px; /* Space for the label */
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1em;
    width: 100%;
    box-sizing: border-box; /* Ensure the input fills the container */
    transition: border-color 0.3s;
}


.application-form-container input:focus,
.application-form-container textarea:focus {
    border-color: #007bff;
    outline: none;
}

.application-form-container input:focus + label,
.application-form-container input:not(:placeholder-shown) + label,
.damn {
    top: -20px; /* Move label above the input */
    left: 12px;
    font-size: 0.8em; /* Smaller font size */
    color: #007bff; /* Change color on focus */
}
.application-form-container .button-container {
    display: flex; /* Ensure buttons are in a row */
    justify-content: center; /* Center the buttons */
    gap: 10px; /* Space between buttons */
    margin-top: 3px; /* Space above the button container */
    margin-left: 0; /* Removed left margin for centering */
    width: 50%; /* Set the container width to 100% */
}

.application-form-container button {
   
    padding: 10px; /* Padding for button size */
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 0.9em; /* Reduced font size */
    transition: background-color 0.3s, transform 0.2s;
    align-items: center;
}

.application-form-container .button-container {
    display:grid;
    justify-content: center;
    align-items: center;
    gap: 30px;
    margin-top: 10px;
    width: 100%;
}

.application-form-container button {
    padding: 10px 12px; /* Reduce padding to make the button smaller */
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 0.85em; /* Keep font size smaller */
    transition: background-color 0.3s, transform 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 200px; /* Set a fixed width for a smaller button */
    min-width: auto;
}


.application-form-container button:hover {
    background-color: #0056b3;
    transform: translateY(-2px);
}

.application-form-container button:disabled {
    background-color: #0fcb5a;
    cursor: not-allowed;
}

.application-form-container h3 {
    margin-top: 30px;
    font-size: 1.5em;
    color: #333;
    border-bottom: 1px solid #ff0080;
    padding-bottom: 10px;
}

.application-form-container .attach-button {
    background-color: #28a745;
    margin-top: 10px;
}

.application-form-container .attach-button:hover {
    background-color: #218838;
}

.application-form-container .checkbox-label {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.application-form-container .checkbox-label input {
    margin-right: 10px;
}

.application-form-container select {
    padding: 12px;
    width: 70%;
    margin-bottom: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1em;
    background-color: #ffffff;
    color: #333;
    appearance: none; /* Remove default arrow */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Custom arrow */
    background-repeat: no-repeat;
    background-position: right 10px center; /* Position the arrow */
    background-size:  10px; /* Size of the arrow */
    transition: border-color 0.3s, background-color 0.3s;
}

.application-form-container select:focus {
    border-color: #007bff;
    outline: none;
    background-color: #f0f8ff; /* Light background on focus */
}

.checkbox-container {
    margin-top: 20px;
}

.checkbox-container p {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    text-align: justify;
    width: 98%;
}

.checkbox-container input {
    margin-right: 20px; /* Space between checkbox and label text */
    width: fit-content;
}

.input-container select {
    width: 100%;              /* Make select full width of container */
    padding: 8px 12px;        /* Comfortable padding */
    font-size: 16px;          /* Readable font size */
    border-radius: 8px;       /* Rounded corners */
    border: 1.5px solid #ccc; /* Light gray border */
    background-color: white;  /* White background */
    box-sizing: border-box;   /* Include padding in width */
    outline: none;            /* Remove default outline */
    cursor: pointer;          /* Pointer cursor on hover */ /* Remove default arrow (optional) */
    appearance: none;
  }
  /* Optional: add a subtle focus style */
  .input-container select:focus {
    border-color: #6366f1;  /* Indigo border on focus */
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.3);
  }

@media only screen and (max-width: 767px) {
    .application-form-container select{
        width: 102%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Pages/ApplicationForm/ApplicationForm.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,oBAAoB,EAAE,yCAAyC;AACnE;;AAEA;;IAEI,aAAa;IACb,iBAAiB,EAAE,wBAAwB;IAC3C,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,sBAAsB,EAAE,yCAAyC;IACjE,6BAA6B;AACjC;;;AAGA;;IAEI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;;;IAGI,UAAU,EAAE,+BAA+B;IAC3C,UAAU;IACV,gBAAgB,EAAE,sBAAsB;IACxC,cAAc,EAAE,0BAA0B;AAC9C;AACA;IACI,aAAa,EAAE,gCAAgC;IAC/C,uBAAuB,EAAE,uBAAuB;IAChD,SAAS,EAAE,0BAA0B;IACrC,eAAe,EAAE,qCAAqC;IACtD,cAAc,EAAE,sCAAsC;IACtD,UAAU,EAAE,oCAAoC;AACpD;;AAEA;;IAEI,aAAa,EAAE,4BAA4B;IAC3C,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAE,sBAAsB;IACxC,iDAAiD;IACjD,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB,EAAE,8CAA8C;IAClE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB,EAAE,2BAA2B;IAC9C,iDAAiD;IACjD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY,EAAE,2CAA2C;IACzD,eAAe;AACnB;;;AAGA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,gBAAgB,EAAE,yBAAyB;IAC3C,yDAA6L,EAAE,iBAAiB;IAChN,4BAA4B;IAC5B,sCAAsC,EAAE,uBAAuB;IAC/D,sBAAsB,EAAE,sBAAsB;IAC9C,oDAAoD;AACxD;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,yBAAyB,EAAE,8BAA8B;AAC7D;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB,EAAE,0CAA0C;IAC9D,kBAAkB;AACtB;;AAEA;IACI,WAAW,eAAe,wCAAwC;IAClE,iBAAiB,SAAS,wBAAwB;IAClD,eAAe,WAAW,uBAAuB;IACjD,kBAAkB,QAAQ,oBAAoB;IAC9C,wBAAwB,EAAE,sBAAsB;IAChD,uBAAuB,GAAG,qBAAqB;IAC/C,sBAAsB,IAAI,6BAA6B;IACvD,aAAa,aAAa,2BAA2B;IACrD,eAAe,WAAW,4BAA4B,EAC5B,oCAAoC;IAE9D,gBAAgB;EAClB;EACA,uCAAuC;EACvC;IACE,qBAAqB,GAAG,2BAA2B;IACnD,6CAA6C;EAC/C;;AAEF;IACI;QACI,WAAW;IACf;EACF","sourcesContent":["/* src/pages/ApplicationForm/ApplicationForm.css */\r\n\r\n.application-form-container {\r\n    padding: 50px;\r\n    max-width: 700px;\r\n    margin: auto;\r\n    margin-top: 40px;\r\n    margin-bottom: 40px;\r\n    border: 1px solid #4f4a4a;\r\n    border-radius: 10px;\r\n    background-color: #ffffff;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n    font-family: 'Arial', sans-serif;\r\n}\r\n\r\n.application-form-container h1 {\r\n    text-align: center;\r\n    font-size: 2.5em;\r\n    color: #333;\r\n    margin-bottom: 40px;\r\n    margin-top: -10px;\r\n    font-weight: bold;\r\n}\r\n\r\n.application-form-container form {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.application-form-container .input-container {\r\n    position: relative;\r\n    margin-bottom: 30px;\r\n}\r\n.application-form-container .display-value-container {\r\n    position: relative;\r\n    margin-bottom: 1px;\r\n}\r\n\r\n.application-form-container label {\r\n    position: absolute;\r\n    left: 12px;\r\n    top: 12px;\r\n    font-weight: bold;\r\n    color: #555;\r\n    transition: 0.2s ease all;\r\n    pointer-events: none; /* Prevents label from capturing clicks */\r\n}\r\n\r\n.application-form-container input,\r\n.application-form-container textarea {\r\n    padding: 20px;\r\n    padding-top: 20px; /* Space for the label */\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    font-size: 1em;\r\n    width: 100%;\r\n    box-sizing: border-box; /* Ensure the input fills the container */\r\n    transition: border-color 0.3s;\r\n}\r\n\r\n\r\n.application-form-container input:focus,\r\n.application-form-container textarea:focus {\r\n    border-color: #007bff;\r\n    outline: none;\r\n}\r\n\r\n.application-form-container input:focus + label,\r\n.application-form-container input:not(:placeholder-shown) + label,\r\n.damn {\r\n    top: -20px; /* Move label above the input */\r\n    left: 12px;\r\n    font-size: 0.8em; /* Smaller font size */\r\n    color: #007bff; /* Change color on focus */\r\n}\r\n.application-form-container .button-container {\r\n    display: flex; /* Ensure buttons are in a row */\r\n    justify-content: center; /* Center the buttons */\r\n    gap: 10px; /* Space between buttons */\r\n    margin-top: 3px; /* Space above the button container */\r\n    margin-left: 0; /* Removed left margin for centering */\r\n    width: 50%; /* Set the container width to 100% */\r\n}\r\n\r\n.application-form-container button {\r\n   \r\n    padding: 10px; /* Padding for button size */\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 0.9em; /* Reduced font size */\r\n    transition: background-color 0.3s, transform 0.2s;\r\n    align-items: center;\r\n}\r\n\r\n.application-form-container .button-container {\r\n    display:grid;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 30px;\r\n    margin-top: 10px;\r\n    width: 100%;\r\n}\r\n\r\n.application-form-container button {\r\n    padding: 10px 12px; /* Reduce padding to make the button smaller */\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 0.85em; /* Keep font size smaller */\r\n    transition: background-color 0.3s, transform 0.2s;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    width: 200px; /* Set a fixed width for a smaller button */\r\n    min-width: auto;\r\n}\r\n\r\n\r\n.application-form-container button:hover {\r\n    background-color: #0056b3;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.application-form-container button:disabled {\r\n    background-color: #0fcb5a;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.application-form-container h3 {\r\n    margin-top: 30px;\r\n    font-size: 1.5em;\r\n    color: #333;\r\n    border-bottom: 1px solid #ff0080;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.application-form-container .attach-button {\r\n    background-color: #28a745;\r\n    margin-top: 10px;\r\n}\r\n\r\n.application-form-container .attach-button:hover {\r\n    background-color: #218838;\r\n}\r\n\r\n.application-form-container .checkbox-label {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.application-form-container .checkbox-label input {\r\n    margin-right: 10px;\r\n}\r\n\r\n.application-form-container select {\r\n    padding: 12px;\r\n    width: 70%;\r\n    margin-bottom: 20px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    font-size: 1em;\r\n    background-color: #ffffff;\r\n    color: #333;\r\n    appearance: none; /* Remove default arrow */\r\n    background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"%23007bff\"><polygon points=\"0,0 20,0 10,10\"/></svg>'); /* Custom arrow */\r\n    background-repeat: no-repeat;\r\n    background-position: right 10px center; /* Position the arrow */\r\n    background-size:  10px; /* Size of the arrow */\r\n    transition: border-color 0.3s, background-color 0.3s;\r\n}\r\n\r\n.application-form-container select:focus {\r\n    border-color: #007bff;\r\n    outline: none;\r\n    background-color: #f0f8ff; /* Light background on focus */\r\n}\r\n\r\n.checkbox-container {\r\n    margin-top: 20px;\r\n}\r\n\r\n.checkbox-container p {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n    text-align: justify;\r\n    width: 98%;\r\n}\r\n\r\n.checkbox-container input {\r\n    margin-right: 20px; /* Space between checkbox and label text */\r\n    width: fit-content;\r\n}\r\n\r\n.input-container select {\r\n    width: 100%;              /* Make select full width of container */\r\n    padding: 8px 12px;        /* Comfortable padding */\r\n    font-size: 16px;          /* Readable font size */\r\n    border-radius: 8px;       /* Rounded corners */\r\n    border: 1.5px solid #ccc; /* Light gray border */\r\n    background-color: white;  /* White background */\r\n    box-sizing: border-box;   /* Include padding in width */\r\n    outline: none;            /* Remove default outline */\r\n    cursor: pointer;          /* Pointer cursor on hover */\r\n    -webkit-appearance: none; /* Remove default arrow (optional) */\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n  }\r\n  /* Optional: add a subtle focus style */\r\n  .input-container select:focus {\r\n    border-color: #6366f1;  /* Indigo border on focus */\r\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.3);\r\n  }\r\n\r\n@media only screen and (max-width: 767px) {\r\n    .application-form-container select{\r\n        width: 102%;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
